<template>
  <div v-loading="loading" class="container-fluid home-page">
    <div id="menu-header" class="home-hero">
      <div class="home-hero-logo">
        <img :src="logo" alt="Progress IMS" />
      </div>
      <div class="home-hero-copy">
        <p class="home-hero-kicker mb-0">{{ $t("homeBusinessAccount") }}</p>
        <h1 class="home-hero-title mb-0">{{ $t("homeWelcome") }}</h1>
      </div>
    </div>

    <div id="user-info" class="home-profile card">
      <div class="home-profile-main">
        <div class="home-identity">
          <div class="avatar avatar-xl home-avatar">
            <img
              src="@/assets/img/logos/CompanyLogo2.jpg"
              alt="profile_image"
              class="w-100"
            />
          </div>
          <div id="nameMenu" class="home-user-meta">
            <h5 class="mb-1">{{ user.fullName }}</h5>
            <p class="mb-0">{{ user.companyName }}</p>
          </div>
        </div>

        <div class="home-actions">
          <div class="nav-wrapper position-relative end-0">
            <div ref="homeTabs" class="home-tabs" role="tablist">
              <span
                class="home-tab-indicator"
                aria-hidden="true"
                :style="tabIndicatorStyle"
              ></span>
              <button
                v-for="tab in homeTabs"
                :key="tab.key"
                :ref="'tabItem-' + tab.key"
                type="button"
                class="home-tab-btn"
                :class="{ active: activeTab === tab.key }"
                role="tab"
                :aria-selected="activeTab === tab.key"
                @click="setActiveTab(tab.key)"
              >
                <span class="home-tab-icon" aria-hidden="true">
                  <i :class="tab.icon"></i>
                </span>
                <span>{{ tab.label }}</span>
              </button>
            </div>
          </div>

          <button
            type="button"
            class="app-theme-toggle home-theme-toggle"
            :aria-label="isDarkTheme ? $t('navThemeToLight') : $t('navThemeToDark')"
            :title="isDarkTheme ? $t('navThemeToLight') : $t('navThemeToDark')"
            @click="onToggleTheme"
          >
            <i :class="isDarkTheme ? 'bi bi-sun' : 'bi bi-moon'" aria-hidden="true"></i>
          </button>

          <div id="dropMenu" class="dropend">
            <a
              id="teamId"
              href="javascript:;"
              class="home-menu-trigger"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              @click="showMenu = !showMenu"
            >
              <i class="fas fa-ellipsis-v"></i>
            </a>
            <ul
              class="dropdown-menu dropdown-menu-end home-dropdown"
              aria-labelledby="dropdownMarketingCard"
            >
              <li @click="signOut()">
                <a class="dropdown-item">
                  <i class="fas fa-sign-out-alt home-dropdown-icon"></i>
                  <span>Etibarlı çıxış</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="home-panel-wrap">
    <Transition name="home-panel" mode="out-in">
      <div v-if="activeTab === 'policy'" key="policy" class="container-fluid home-panel">
        <policies :policy-list="policyList"></policies>
      </div>
      <div v-else-if="activeTab === 'requests'" key="requests" class="container-fluid home-panel">
        <requests :policy-list="policyList"></requests>
      </div>
      <div v-else key="password" class="container-fluid home-panel">
        <password :policy-list="policyList"></password>
      </div>
    </Transition>
  </div>
</template>

<script>
import medical from "@/assets/img/icons/insurence/medical.png";
import motor from "@/assets/img/icons/insurence/motor.png";
import property from "@/assets/img/icons/insurence/property.png";
import CryptoJS from "crypto-js";
import Policies from "./components/Policies.vue";
import Password from "./components/Password/Password.vue";
import { getBrandLogoWhite, weblink } from "@/project/Source/helper.js";
import Requests from "./components/Requests/Requests.vue";
import Source from "../Source/claim.js";
import { getTheme, toggleTheme } from "@/project/Source/theme";

export default {
  name: "DashboardDefault",
  components: {
    Policies,
    Password,
    Requests,
  },
  data() {
    return {
      logo: getBrandLogoWhite(),
      activeTab: "policy",
      tabIndicator: { left: 0, width: 0, ready: false },
      insureTypes: [
        {
          id: 1,
          name: "Medical",
          image: medical,
          isActive: false,
        },
        {
          id: 2,
          name: "Motor",
          image: motor,
          isActive: false,
        },
        {
          id: 3,
          name: "Əmlak",
          image: property,
          isActive: false,
        },
      ],
      loading: false,
      showMenu: false,
      theme: getTheme(),
      medical,
      motor,
      property,
      policyList: null,
      requestsList: null,
      iconBackground: "bg-gradient-success",
      onResizeTabs: null,
    };
  },
  computed: {
    homeTabs() {
      return [
        { key: "policy", label: this.$t("homeTabPolicies"), icon: "fas fa-file-alt" },
        { key: "requests", label: this.$t("homeTabNotifications"), icon: "fas fa-bell" },
        { key: "password", label: this.$t("homeTabPassword"), icon: "fas fa-key" },
      ];
    },
    policyVis() {
      return this.activeTab === "policy";
    },
    requestVis() {
      return this.activeTab === "requests";
    },
    changePasVis() {
      return this.activeTab === "password";
    },
    tabIndicatorStyle() {
      return {
        width: `${this.tabIndicator.width}px`,
        transform: `translate3d(${this.tabIndicator.left}px, 0, 0)`,
        opacity: this.tabIndicator.ready ? 1 : 0,
      };
    },
    isDarkTheme() {
      return this.theme === "dark";
    },
    userName() {
      return JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      ).fullName;
    },
    companyNameStr() {
      return JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      ).companyName;
    },
    user() {
      return JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      );
    },
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler() {
        this.syncTabFromRoute();
      },
    },
    "$i18n.locale": {
      handler() {
        this.$nextTick(() => this.updateTabIndicator());
      },
    },
  },
  mounted() {
    this.loading = true;
    const data = {
      id: JSON.parse(
        CryptoJS.AES.decrypt(
          window.localStorage.getItem("user"),
          "secret_key"
        ).toString(CryptoJS.enc.Utf8)
      ).companyId,
      requestCorrelationId: "string",
    };
    Source.MedicalPolicyByCompany(data).then((response) => {
      this.policyList = response.data.data;
      this.loading = false;
    });
    this.$store.state.isAbsolute = true;
    this.$nextTick(() => {
      this.updateTabIndicator();
      requestAnimationFrame(() => this.updateTabIndicator());
    });
    this.onResizeTabs = () => this.updateTabIndicator();
    window.addEventListener("resize", this.onResizeTabs);
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    if (this.onResizeTabs) {
      window.removeEventListener("resize", this.onResizeTabs);
    }
  },
  methods: {
    syncTabFromRoute() {
      const tab = this.$route.query.tab;
      const validTab = this.homeTabs.some((item) => item.key === tab);

      if (validTab) {
        this.setActiveTab(tab);
        return;
      }

      if (!tab) {
        this.setActiveTab("policy");
      }
    },
    setActiveTab(key) {
      if (this.activeTab === key) {
        return;
      }
      this.activeTab = key;
      this.$nextTick(() => this.updateTabIndicator());
    },
    onToggleTheme() {
      this.theme = toggleTheme();
    },
    updateTabIndicator() {
      const list = this.$refs.homeTabs;
      const itemRef = this.$refs[`tabItem-${this.activeTab}`];
      const item = Array.isArray(itemRef) ? itemRef[0] : itemRef;

      if (!list || !item) {
        return;
      }

      this.tabIndicator = {
        left: item.offsetLeft,
        width: item.offsetWidth,
        ready: true,
      };
    },
    signOut() {
      window.location.href = weblink + "signIn";
      window.localStorage.setItem(
        "jwt",
        CryptoJS.AES.encrypt(JSON.stringify("none"), "secret_key").toString()
      );
      window.localStorage.setItem(
        "roles",
        CryptoJS.AES.encrypt(
          JSON.stringify([{ id: null }]),
          "secret_key"
        ).toString()
      );
      window.localStorage.setItem(
        "user",
        CryptoJS.AES.encrypt(
          JSON.stringify([{ id: null }]),
          "secret_key"
        ).toString()
      );
    },
    showPolicy() {
      this.setActiveTab("policy");
    },
    showRequests() {
      this.setActiveTab("requests");
    },
    showSettings() {
      this.setActiveTab("password");
    },
  },
};
</script>

<style scoped>
.home-page {
  padding-top: 1rem;
}

.home-hero {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 272px;
  padding: 2rem 1.5rem 4.5rem;
  border-radius: 16px;
  overflow: hidden;
  background:
    radial-gradient(circle at 12% 20%, rgba(255, 255, 255, 0.18), transparent 36%),
    linear-gradient(135deg, var(--app-brand-deep) 0%, var(--bs-info) 55%, var(--bs-info-soft) 100%);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.12);
}

.home-hero-logo {
  position: absolute;
  top: 1.25rem;
  left: 1.35rem;
}

.home-hero-logo img {
  display: block;
  max-height: 56px;
  max-width: 220px;
  width: auto;
  object-fit: contain;
}

.home-hero-copy {
  position: relative;
  z-index: 1;
  text-align: center;
  color: #fff;
}

.home-hero-kicker {
  margin-bottom: 0.35rem;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.78);
}

.home-hero-title {
  font-size: clamp(1.8rem, 3vw, 2.4rem);
  font-weight: 750;
  letter-spacing: -0.03em;
  color: #fff;
}

.home-profile {
  position: relative;
  z-index: 2;
  margin: -2.75rem 1rem 0;
  padding: 1.25rem 1.4rem;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface);
  box-shadow: var(--app-shadow-md);
  color: var(--app-text);
}

.home-profile-main {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
}

.home-identity {
  display: flex;
  align-items: center;
  gap: 1rem;
  min-width: 0;
}

.home-avatar {
  flex: 0 0 auto;
  overflow: hidden;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  box-shadow: var(--app-shadow);
}

.home-user-meta h5 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--app-heading);
}

.home-user-meta p {
  font-size: 0.92rem;
  font-weight: 600;
  color: var(--app-text);
}

.home-actions {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.home-actions .nav-wrapper {
  min-width: 0;
}

.home-tabs {
  position: relative;
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.2rem;
  margin: 0;
  padding: 0.3rem;
  border: 1px solid var(--app-border);
  border-radius: 14px;
  background: var(--app-surface-soft);
  box-shadow: none;
  isolation: isolate;
}

.home-tab-indicator {
  position: absolute;
  top: 0.3rem;
  left: 0;
  z-index: 0;
  height: calc(100% - 0.6rem);
  border-radius: 11px;
  background: var(--app-surface-elevated);
  border: 1px solid var(--app-border);
  box-shadow: none;
  transition:
    transform 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    width 0.28s cubic-bezier(0.22, 1, 0.36, 1),
    opacity 0.15s ease;
  pointer-events: none;
}

.home-tab-btn {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 2.55rem;
  margin: 0;
  padding: 0.5rem 0.95rem;
  border: 0;
  border-radius: 11px;
  background: transparent;
  color: var(--app-text);
  font-family: inherit;
  font-size: 0.9rem;
  font-weight: 650;
  letter-spacing: 0.01em;
  white-space: nowrap;
  cursor: pointer;
  transition: color 0.2s ease;
}

.home-tab-btn:hover {
  color: var(--app-heading);
}

.home-tab-btn.active {
  color: var(--app-heading);
}

.home-tab-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.55rem;
  height: 1.55rem;
  border-radius: 8px;
  background: var(--app-surface-tint);
  color: var(--app-text);
  font-size: 0.72rem;
  box-shadow: none;
  transition:
    background-color 0.22s ease,
    color 0.22s ease;
}

.home-tab-icon .fa-key {
  transform: scaleX(-1);
}

.home-tab-btn.active .home-tab-icon {
  background: var(--bs-info);
  color: #fff;
  box-shadow: none;
}

.home-panel-wrap {
  min-height: 0;
}

.home-panel {
  padding-top: 1rem !important;
  padding-bottom: 1.25rem !important;
}

.home-panel-enter-active,
.home-panel-leave-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}

.home-panel-enter-from,
.home-panel-leave-to {
  opacity: 0;
  transform: translateY(6px);
}

.home-theme-toggle {
  width: 2.55rem;
  height: 2.55rem;
  border-radius: 12px;
  flex: 0 0 auto;
}

.home-menu-trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.55rem;
  height: 2.55rem;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-elevated);
  color: var(--app-text) !important;
  font-size: 0.95rem;
  box-shadow: none;
  transition:
    color 0.18s ease,
    border-color 0.18s ease,
    background 0.18s ease;
}

.home-menu-trigger:hover {
  color: var(--app-heading) !important;
  border-color: var(--app-border-strong);
  background: var(--app-surface-tint);
}

.home-dropdown {
  min-width: 11.5rem;
  margin-top: 0.45rem !important;
  padding: 0.4rem;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-elevated);
  box-shadow: var(--app-shadow-md);
}

.home-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.65rem 0.75rem;
  border-radius: 9px;
  font-size: 0.9rem;
  font-weight: 600;
  color: #b91c1c;
}

.home-dropdown .dropdown-item:hover {
  background: color-mix(in srgb, #ef4444 12%, var(--app-surface));
  color: #991b1b;
}

:global(html[data-theme="dark"]) .home-dropdown .dropdown-item {
  color: #f87171;
}

:global(html[data-theme="dark"]) .home-dropdown .dropdown-item:hover {
  color: #fecaca;
}

.home-dropdown-icon {
  font-size: 0.85rem;
  transform: scaleX(-1);
}

@media (max-width: 767.98px) {
  .home-hero {
    min-height: 240px;
    padding: 1.75rem 1rem 4.5rem;
    justify-content: flex-start;
  }

  .home-hero-logo {
    position: static;
    margin-bottom: 1rem;
  }

  .home-hero-copy {
    text-align: left;
  }

  .home-profile {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .home-profile-main {
    align-items: flex-start;
  }

  .home-actions {
    width: 100%;
    justify-content: space-between;
  }

  .home-tabs {
    width: 100%;
  }

  .home-tab-btn {
    flex: 1 1 auto;
    justify-content: center;
    padding: 0.5rem 0.65rem;
    font-size: 0.84rem;
  }
}
</style>
